<template>
  <div class="history">
    <div class="container hist-head">
      <div class="hist-table">
        <form @submit.prevent="getHistory" ref="searchForm">
          <div class="hist-row">
            <div>
              <label for="searchUsername" class="hist-item">{{
                translations[language][USERNAME]
              }}</label>
              <select class="hist-item" name="username">
                <option value>{{ parseTranslation(NONE) }}</option>
                <option v-for="user in users" :key="user.username" :value="user.username">
                  {{ user.username }}
                </option>
              </select>
            </div>
            <div>
              <label for="searchMethod" class="hist-item">{{
                translations[language][METHOD]
              }}</label>
              <select class="hist-item" name="method">
                <option value>{{ parseTranslation(NONE) }}</option>
                <option value="GET">{{ parseTranslation(GET) }}</option>
                <option value="POST">{{ parseTranslation(POST) }}</option>
                <option value="PUT">{{ parseTranslation(PUT) }}</option>
                <option value="DELETE">{{ parseTranslation(DELETE) }}</option>
              </select>
            </div>
            <div>
              <label for="searchStatus" class="hist-item">Status</label>
              <select class="hist-item" name="status">
                <option value>{{ parseTranslation(NONE) }}</option>
                <option value="Success">{{ parseTranslation(SUCCESS) }}</option>
                <option value="Client Error">{{
                  translations[language][CLIENT_ERROR]
                }}</option>
                <option value="Server Error">{{
                  translations[language][SERVER_ERROR]
                }}</option>
                <option value="Unknow">{{ parseTranslation(UNKNOWN) }}</option>
              </select>
            </div>
            <div>
              <label for="searchRoute" class="hist-item">{{
                translations[language][ROUTE]
              }}</label>
              <input class="hist-item" name="route" type="text" />
            </div>
            <div>
              <label for="searchSort" class="hist-item">{{
                translations[language][SORT_BY]
              }}</label>
              <select class="hist-item" name="sort">
                <option value="0"
                  >{{ parseTranslation(NEWEST) }} / {{ parseTranslation(OLDEST) }}</option
                >
                <option value="1"
                  >{{ parseTranslation(OLDEST) }} / {{ parseTranslation(NEWEST) }}</option
                >
              </select>
            </div>
          </div>
          <button type="submit" value="search">
            {{ parseTranslation(SEARCH) }}
          </button>
        </form>
      </div>
    </div>
    <table class="container" v-if="logs">
      <thead>
        <tr>
          <th class="small">{{ parseTranslation(USERNAME) }}</th>
          <th class="small">{{ parseTranslation(METHOD) }}</th>
          <th class="small">{{ parseTranslation(STATUS) }}</th>
          <th class="small">{{ parseTranslation(ROUTE) }}</th>
          <th class="small">{{ parseTranslation(TIME) }}</th>
          <th class="minimal">{{ parseTranslation(PARAMS) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="ind_log in logs.entries()" :key="ind_log[0]">
          <td class="small">{{ ind_log[1].username }}</td>
          <td class="small">{{ ind_log[1].method }}</td>
          <td class="small">{{ ind_log[1].status }}</td>
          <td class="small">{{ ind_log[1].route }}</td>
          <td class="small">{{ ind_log[1].time }}</td>
          <td class="minimal">
            <button @click="dropdown" class="btn">
              {{ parseTranslation(PARAMS) }}
              <img v-if="$store.getters.darkmode" src="@/assets/imgs/seta.svg" />
              <img v-else src="@/assets/imgs/seta_dark.svg" />
            </button>
            <div class="dropdown">
              <p
                v-for="(value, key, index) in ind_log[1].params"
                :key="ind_log[0] + index"
              >
                <span>{{ key }}:</span>
                {{ value }}
              </p>
            </div>
          </td>
        </tr>
      </tbody>
      <Pagination
        :surveysPerPage="'10'"
        :totalSurveys="totalItems"
        :pageToGo="'history'"
        :page="page"
      />
    </table>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

import Pagination from '@/components/Pagination'

import * as translationAdminHistory from './index.translations'

const { default: translations, ...translationKeys } = translationAdminHistory

export default {
  name: 'history',

  components: {
    Pagination,
  },

  props: {
    users: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
      logs: [],
      totalItems: 0,
    }
  },

  computed: {
    page() {
      this.getHistory()
      return this.$route.query._page
    },
    dropdowns() {
      return document.querySelectorAll('.dropdown')
    },
  },

  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall']),

    async getHistory() {
      const data = new FormData(this.$refs.searchForm)

      const deleteKeys = []

      data.forEach((val, key) => {
        if (!val) {
          deleteKeys.push(key)
        }
      })

      for (const key in deleteKeys) {
        data.delete(deleteKeys[key])
      }

      const page =
        typeof this.$route.query._page !== 'undefined' ? +this.$route.query._page : 1

      const json = {
        pag: page,
        per_page: 10,
        sort: '0',
      }

      data.forEach((val, key) => {
        if (val) json[key] = val
      })

      const logs = await this.executeSurveyAPICall({
        path: 'log',
        method: 'POST',
        payload: json,
      })

      if (!logs) return

      this.totalItems = logs.length
      this.logs = totalItems
    },

    dropdown(e) {
      const element = e.currentTarget.parentElement
      element.classList.toggle('active')
      this.outsideClick(element, () => {
        element.classList.remove('active')
      })
    },

    outsideClick(element, callback) {
      const html = document.documentElement
      const outside = 'data-outside'
      if (!element.hasAttribute(outside)) {
        setTimeout(() => {
          html.addEventListener('click', e => {
            this.handleOutsideClick(e, html, outside, element, callback)
          })
        })
        element.setAttribute(outside, '')
      }
    },

    handleOutsideClick(e, html, outside, element, callback) {
      if (!element.contains(e.target)) {
        element.removeAttribute(outside)
        html.removeEventListener('click', this.handleOutsideClick)
        callback()
      }
    },
  },

  mounted() {
    if (!Object.prototype.hasOwnProperty.call(this.$route.query, '_page')) {
      this.$router.push({ query: { _page: 1 } })
    }
  },
}
</script>
<style lang="scss" scoped>
.hist-head {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-top: 60px;
}
.hist-row {
  display: flex;
  flex-wrap: wrap;
  > div {
    margin-right: 15px;
    &:last-of-type {
      margin-right: 0;
    }
  }
}
.hist-item {
  flex: 1 1 0;
  min-width: 70px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  margin-top: 15px;
  border-radius: 3px;
  @include tipography(15);
  color: #fff;
  &:last-child {
    margin-right: 0;
  }
  .light & {
    color: $gray-6;
  }
}

select.hist-item,
input.hist-item {
  background: rgba(0, 0, 0, 0);
  @include tipography(14);
  padding: 2px 8px;
  outline: none;
  border-radius: 15px;
  border: 1px solid #fff;
  width: 150px;
  &:hover,
  &:focus {
    box-shadow: 0px 0px 6px $gray;
  }
  option {
    color: $main-two;
  }
}

select.hist-item,
input.hist-item {
  .light & {
    border: 1px solid $gray-5;
  }
}

label[for^='se'] {
  font-weight: bold;
  margin-top: 0;
}

form {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  button {
    margin-top: 15px;
    @include btn-style;
    max-width: 150px;
  }
}

table {
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  padding-bottom: 60px;
  thead {
    padding-bottom: 10px;
    border: none;
    font-weight: bold;
    text-transform: uppercase;
    @include tipography(16);
    color: rgba(255, 255, 255, 0.5);
    tr {
      border: none;

      &:first-child {
        border: none;
      }
      th {
        border: none;
        margin: 0 10px;
        min-width: 100px;
      }
    }
  }

  tbody {
    @include tipography(14);
    tr {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 15px;
      padding: 5px 0;
      margin-bottom: 10px;
    }
    td {
      border-right: 1px solid #fff;
      height: 30px;
      position: relative;
      margin: 0 10px;
      min-width: 100px;
      &.active {
        .dropdown {
          display: block;
          animation: growDown 400ms ease-in-out forwards;
          transform-origin: top center;
        }
      }
      button {
        display: flex;
        align-items: center;
        background: none;
        border: none;
        color: #fff;
        outline: none;
        cursor: pointer;
        img {
          width: 10px;
          margin-left: 5px;
        }
      }
    }
  }
  thead,
  tbody {
    display: flex;
    flex-direction: column;
    tr {
      display: flex;
      td,
      th {
        display: flex;
        justify-content: center;
        align-items: center;
        &:last-child {
          border-right: none;
        }
        &.minimal {
          flex: 1 1 0;
        }
        &.small {
          flex: 2 1 0;
        }
        &.med {
          flex: 4 1 0;
        }
        &.big {
          flex: 8 1 0;
        }
      }
    }
  }
  .light & {
    thead {
      color: $gray-6;
    }
  }
}

tbody {
  .light & {
    color: $gray-6;
    tr {
      background: rgba(0, 0, 0, 0.05);
    }
    td {
      border-right: 1px solid $gray-5;
      button {
        color: $gray-6;
      }
    }
  }
}

.dropdown {
  display: none;
  position: absolute;
  top: 30px;
  min-width: 200px;
  background: $white;
  color: $gray-6;
  border-radius: 4px;
  padding: 10px;
  z-index: 20;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  p {
    display: flex;
    margin-bottom: 2px;
    span {
      margin-right: 5px;
    }
  }
  .light & {
    background: $main-two;
    color: #fff;
  }
}

@media (max-width: 576.98px) {
  .hist-row {
    justify-content: space-between;
    > div {
      margin-right: 7.5px;
      margin-left: 7.5px;
    }
  }
  table {
    overflow-x: auto;
    tbody {
      tr {
        width: 720px !important;
      }
    }
  }
}
</style>
